export const IsItLessThanFourHours = (departure) => {
	let diff = new Date(departure).getTime() - new Date().getTime()

	if (diff < 0) {
		diff = diff * -1
	}

	return diff <= 4 * 60 * 60 * 1000
}

export const IsItMoreThanFourHours = (departure) => {
	let diff = new Date(departure).getTime() - new Date().getTime()

	if (diff < 0) {
		diff = diff * -1
	}

	return diff >= 4 * 60 * 60 * 1000
}

export const has150DaysPassed = (date) => {
	let differenceInMilliseconds = new Date() - new Date(date)

	if (differenceInMilliseconds < 0) {
		differenceInMilliseconds = differenceInMilliseconds * -1
	}

	const differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24)
	return differenceInDays > 150
}
